import React from 'react';
import { Text, TouchableOpacity, StyleSheet, Linking } from 'react-native';
import { colors } from '@/styles/colors';

interface TextLinkProps {
  href: string;
  children: React.ReactNode;
  onPress?: () => void;
}

export const TextLink: React.FC<TextLinkProps> = ({ href, children, onPress }) => {
  const handlePress = () => {
    if (onPress) {
      onPress();
    } else if (href.startsWith('http') || href.startsWith('mailto:')) {
      Linking.openURL(href);
    }
    // For internal navigation, onPress should handle it
  };

  return (
    <TouchableOpacity onPress={handlePress}>
      <Text style={styles.link}>{children}</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  link: {
    color: colors.link,
    textDecorationLine: 'underline',
    fontSize: 14,
    fontWeight: '500',
  },
});
